export default "__VITE_ASSET__BsPMyCMd__"